module.exports = __webpack_public_path__ + "static/media/item_2_5.6e5137f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_5.png
// module id = 112
// module chunks = 0